import { _ as __rest, a as __assign } from './tslib.es6-2259bcab.js';
import { c as classNames } from './index-444bb648.js';
import * as React from 'react';
import React__default, { useState } from 'react';
import './countries-4c9d3a3b.js';
import { u as useTheme } from './ThemeProvider-91c278af.js';

var UserIcon = function (_a) {
    var _b = _a.fillColor, fillColor = _b === void 0 ? "currentColor" : _b, props = __rest(_a, ["fillColor"]);
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.8169 3.64215C9.65525 3.64215 7.09223 6.20517 7.09223 9.36682C7.09223 12.5285 9.65525 15.0915 12.8169 15.0915C15.9785 15.0915 18.5416 12.5285 18.5416 9.36682C18.5416 6.20517 15.9785 3.64215 12.8169 3.64215ZM4.45008 9.36682C4.45008 4.74595 8.19603 1 12.8169 1C17.4378 1 21.1837 4.74595 21.1837 9.36682C21.1837 13.9877 17.4378 17.7336 12.8169 17.7336C8.19603 17.7336 4.45008 13.9877 4.45008 9.36682Z", fill: fillColor }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.8169 17.7326C10.8842 17.7326 8.98565 18.2413 7.31197 19.2077C5.63829 20.1741 4.24851 21.5641 3.28234 23.2379C2.91759 23.8698 2.10965 24.0864 1.47776 23.7216C0.845864 23.3569 0.629298 22.549 0.994045 21.9171C2.1921 19.8415 3.91543 18.118 5.99079 16.9196C8.06615 15.7213 10.4204 15.0904 12.8169 15.0904C15.2134 15.0904 17.5676 15.7213 19.643 16.9196C21.7184 18.118 23.4417 19.8415 24.6397 21.9171C25.0045 22.549 24.7879 23.3569 24.156 23.7216C23.5241 24.0864 22.7162 23.8698 22.3515 23.2379C21.3853 21.5641 19.9955 20.1741 18.3218 19.2077C16.6481 18.2413 14.7495 17.7326 12.8169 17.7326Z", fill: fillColor })));
};

var styles = {"container":"Avatar_container_00fbc60a","skeleton":"Avatar_skeleton_00fbc60a","image":"Avatar_image_00fbc60a"};

var Avatar = React__default.forwardRef(function Avatar(_a, ref) {
    var _b, _c;
    var src = _a.src, srcSet = _a.srcSet, children = _a.children, alt = _a.alt, size = _a.size, isSkeleton = _a.isSkeleton, color = _a.color, _d = _a["data-testid"], testId = _d === void 0 ? "avatar" : _d, imageProps = __rest(_a, ["src", "srcSet", "children", "alt", "size", "isSkeleton", "color", "data-testid"]);
    // Prevent background showing while image is loading
    var _e = useState(Boolean(src || srcSet)), loading = _e[0], setLoading = _e[1];
    var _f = useState(false), error = _f[0], setError = _f[1];
    var colors = useTheme().colors;
    var renderFallback = function () {
        if (alt === null || alt === void 0 ? void 0 : alt.slice(0, 1)) {
            return alt.slice(0, 1);
        }
        if (children) {
            return children;
        }
        return React__default.createElement(UserIcon, null);
    };
    var onLoad = function () {
        setLoading(false);
        setError(false);
    };
    var onError = function () {
        setLoading(false);
        setError(true);
    };
    var labelColour = color ? colors["color-ui-".concat(color, "-dark")] : undefined;
    var backgroundColour = color ? colors["color-ui-".concat(color, "-10")] : undefined;
    var borderColour = color ? colors["color-ui-".concat(color, "-20")] : undefined;
    var customColourStyles = color
        ? {
            color: labelColour,
            background: backgroundColour,
            border: borderColour ? "solid 1px ".concat(borderColour) : undefined,
        }
        : {};
    return (React__default.createElement("div", { ref: ref, className: classNames(styles.container, (_b = {},
            _b[styles.skeleton] = loading || isSkeleton,
            _b)), style: __assign(__assign({}, customColourStyles), (_c = {}, _c["--avatar-diameter"] = typeof size === "number" ? "".concat(size, "px") : size, _c)), "data-testid": testId }, (src || srcSet) && !error ? (React__default.createElement("img", __assign({ className: styles.image, src: src, alt: alt }, imageProps, { onLoad: onLoad, onError: onError }))) : (renderFallback())));
});

export { Avatar as A, UserIcon as U };
